import React, { useState } from "react";
import {
  FormControl,
  FormLabel,
  Input,
  Button,
  Stack,
  Select,
  useColorModeValue,
} from "@chakra-ui/react";
import { COLORS } from "../../../constants/colors";
import { errorNotifier, successNotifier } from "../../../components/NotificationHandler";
import { timeout } from "../../../components/utils/timeout";
import { updateFamilyMember } from "../services";

export const EditFamilyMemberForm = ({ onClose, userId, member, refreshFamily }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    familyName: member?.familyName || "",
    familyPhone: member?.familyPhone || "",
    relationship: member?.relationship || "",
    userId: userId,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
        console.log("member id", member?._id);
      await updateFamilyMember(member?._id, formData);
      successNotifier("Family member updated successfully");
      timeout(() => {
        refreshFamily();
        onClose();
      }, 2000);
    } catch (error) {
      errorNotifier(
        error?.response?.data?.message || "Error updating family member"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={4}>
        <FormControl isRequired>
          <FormLabel>Full Name</FormLabel>
          <Input
            name="familyName"
            value={formData.familyName}
            onChange={handleChange}
            placeholder="Enter full name"
          />
        </FormControl>

        <FormControl>
          <FormLabel>Phone Number</FormLabel>
          <Input
            name="familyPhone"
            value={formData.familyPhone}
            onChange={handleChange}
            placeholder="Enter phone number"
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Relationship</FormLabel>
          <Select
            name="relationship"
            value={formData.relationship}
            onChange={handleChange}
          >
            <option>Select relationship</option>
            <option value="spouse">Spouse</option>
            <option value="son">Son</option>
            <option value="daughter">Daughter</option>
            <option value="sibling">Sibling</option>
            <option value="uncle">Uncle</option>
            <option value="aunt">Aunt</option>
            <option value="parent">Parent</option>
            <option value="in-law">In-law</option>
            <option value="cousin">Cousin</option>
            <option value="nephew">Nephew</option>
            <option value="niece">Niece</option>
            <option value="friend">Friend</option>
            <option value="others">Others</option>
          </Select>
        </FormControl>


        <Button
          type="submit"
          bg={COLORS.primary}
          color="white"
          size="lg"
          w="100%"
          isLoading={isSubmitting}
          _hover={{
            bg: COLORS.primaryDark,
          }}
        >
          Update Family Member
        </Button>
      </Stack>
    </form>
  );
};
